module.exports = __webpack_public_path__ + "static/media/CanadaTechNetwork.eb1fd1ab.webp";